import clsx from 'clsx'

import mainStyles from 'assets/css/main.module.scss'
import BigText from 'components/bigText/BigText'
import Bubble from 'components/common/bubble/Bubble'
import FrameworkWheel, { FrameworkWheelPage } from 'components/interactiveNavigation/FrameworkWheel'

import styles from './PageBanner.module.scss'

interface Props {
  heading: string
  description: string
  showBubble?: boolean
  bubbleText?: string
  bubbleTextColor?: string
  bubbleBackgroundColor?: string
  backgroundStyle?: React.CSSProperties
  showNavigationCircle?: boolean
  bigTextFillColor?: string
  page: FrameworkWheelPage
  reducedTop?: boolean
}
const PageBanner = ({
  heading,
  description,
  showBubble = false,
  bubbleText = '',
  bubbleTextColor = '#000000',
  bubbleBackgroundColor = '#EBFF00',
  backgroundStyle = {},
  showNavigationCircle = false,
  bigTextFillColor,
  page,
  reducedTop = false,
}: Props) => {
  return (
    <div className={styles.PageBanner} style={backgroundStyle}>
      <div className={styles.bigText}>
        <BigText fillColor={bigTextFillColor} />
      </div>
      <div className={clsx(mainStyles.container, 'w-full relative')}>
        <div className={clsx(styles.content, showNavigationCircle && 'max-w-[760px]', reducedTop && styles.reducedTop)}>
          <div className={styles.heading}>
            <div className="relative w-fit">
              {heading}
              {showBubble && (
                <Bubble
                  className="translate-x-full -right-[20px] -top-[30px] w-max"
                  text={bubbleText}
                  color={bubbleBackgroundColor}
                  {...(bubbleTextColor && { fontStyle: `color: ${bubbleTextColor}` })}
                />
              )}
            </div>
          </div>
          <div className={clsx(styles.description)}>{description}</div>
        </div>

        {showNavigationCircle && (
          <div className={styles.NavigationCircle}>
            <FrameworkWheel active={page} />
            {/* <img src={InteractiveCircle} alt="Interactive Circle" /> */}
          </div>
        )}
      </div>
    </div>
  )
}

export default PageBanner
